import { render, staticRenderFns } from "./NumberSlotControls.vue?vue&type=template&id=095c6589&scoped=true&"
import script from "./NumberSlotControls.vue?vue&type=script&lang=ts&"
export * from "./NumberSlotControls.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095c6589",
  null
  
)

export default component.exports